import { Component } from 'react';

import './Contacts.css';

import { background_10 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import { contacts } from '../../utils/contacts';
import Contact from '../../components/Contact/Contact';
import { API_URL, get_page_title } from '../../utils/config';
import { Helmet } from 'react-helmet';
import request from '@acri-tools/react-tools/utils/request';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';


const contact_keys = Object.keys(contacts);

interface Props { }


interface ContactInterface {
    id?: any
    name: string
    email: string
    type: string
}

interface State {
    loading: boolean
    maintenanceContacts: {
        recipients: any
        copy_to: any
    }
}


class Contacts extends Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            loading: false,
            maintenanceContacts: {
                recipients: [],
                copy_to: []
            }
        }
    }

    componentDidMount() {
        this.fetchITContacts(true);
    }

    fetchITContacts = async (load?: boolean) => {
        if (load) this.setState({ loading: true });
        try {
            let res = await request(`${API_URL}/api/v1/contacts`, { method: 'get' });

            const contacts = res.data.value;
            const recipients = contacts.filter((c: ContactInterface) => c.type === 'RECIPIENT');
            const copy_to = contacts.filter((c: ContactInterface) => c.type === 'COPY');

            this.setState({
                maintenanceContacts: {
                    recipients,
                    copy_to,
                }
            });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch` });
            toast_request_error(e);
        }
        finally {
            if (load) this.setState({ loading: false })
        }
    }


    renderContacts = (contacts: any[]) =>
        contacts.map((contact, index) => {
            const hasName = !!contact?.name;
            const name = hasName
                ? `${contact.name} <${contact.email}>`
                : contact.email;

            return (
                <span key={index}>
                    {hasName && `${contact.name} `}
                    <a
                        className="rt-contact-detail-value maintenance-contacts-email"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`mailto:${contact.email}`}
                    >
                        {contact.email}
                    </a>
                    {index < contacts.length - 1 ? '; ' : ''}
                </span>
            );
        });

    render() {
        return (
            <Page
                id="contacts"
                banner={{
                    title: "contacts",
                    bannerImage: background_10,
                    topBar: true
                }}
                footer
            >
                <Helmet>
                    <title>{get_page_title('DAMPS - Contacts')}</title>
                    <meta
                        name="description"
                        content="Contact information for DAMPS"
                    />
                </Helmet>
                <div className="page-content">
                    <div className="centered-content padding">
                        {
                            contact_keys.map((company: string, idx: number) => (
                                <div key={idx}>
                                    <h3 className="title-5">{company}</h3>
                                    <div className="contacts">
                                        {
                                            contacts[company]?.map((contact: any, idx_c: number) => (
                                                <Contact key={idx_c} contact={contact} />
                                            ))
                                        }
                                    </div>
                                    {
                                        contact_keys.length > idx + 1 &&
                                        <div className="separator" />
                                    }
                                </div>

                            ))
                        }

                        <div>
                            <div className="separator" />

                            <h3 className="title-5">IT Maintenance Distribution List</h3>
                            <div className="contacts maintenance-contacts">
                                <p>
                                    <span className="title-contacts-small">Recipients:</span>{' '}
                                    {this.renderContacts(this.state.maintenanceContacts.recipients)}
                                </p>
                                <p>
                                    <span className="title-contacts-small">Copy to:</span>{' '}
                                    {this.renderContacts(this.state.maintenanceContacts.copy_to)}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </Page>
        );
    }

};


export default Contacts;
